var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.04,25.35c.01,.27,.12,.53,.3,.73l25.96,26.77c.15,.15,.35,.24,.56,.26h.3c.21-.03,.4-.12,.55-.26l25.96-26.77c.19-.2,.31-.45,.34-.73l-26.74-5.09L5.04,25.35Z",
    fill: "#67b0fe",
    id: "l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46,25.35H23.04l8.8,27.76c.1,.02,.2,.02,.3,0l9.31-27.76Z",
    fill: "#67b0fe",
    id: "m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.47,11.07c-.28,.14-.53,.35-.72,.6L5.24,24.53c-.16,.24-.23,.53-.2,.81H58.99c.03-.29-.05-.59-.22-.83l-9.08-12.83c-.18-.26-.42-.46-.7-.61H15.47Z",
    fill: "#67b0fe",
    id: "n"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.23,10.86l-9.18,14.48h18.41l-9.23-14.48Z",
    fill: "#67b0fe",
    id: "o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.23,10.86l9.23,14.48,7.53-14.26c-.28-.14-.59-.22-.9-.22h-15.86Z",
    fill: "#67b0fe",
    id: "p"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37,10.86c-.31,0-.62,.07-.9,.21l7.58,14.27,9.18-14.48h-15.86Z",
    fill: "#67b0fe",
    id: "q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.51,11.11c-.55-.78-1.46-1.25-2.42-1.25H16.37c-.95,0-1.85,.46-2.42,1.22L4.43,23.94c-.64,.87-.56,2.06,.19,2.83l25.95,26.77c.74,.76,1.97,.85,2.85,0l25.95-26.77c.74-.77,.84-1.96,.22-2.83l-9.08-12.83Zm-10.44,15.24l-8.05,24-7.61-24h15.66Zm-15.21-2l7.37-11.62,7.4,11.62h-14.77Zm9.19-12.49h13.39l-6.07,11.5-7.32-11.5Zm-10.93,11.5l-6.1-11.5h13.39l-7.29,11.5Zm6.64,26.47L6.99,26.35h15.32l7.45,23.48Zm12.42-23.48h14.82l-22.67,23.4,7.85-23.4Zm.94-2l6.11-11.58,8.2,11.58h-14.31ZM15.22,12.73l6.17,11.62H6.62L15.22,12.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "r"
  }), /*#__PURE__*/React.createElement("g", {
    id: "s"
  }), /*#__PURE__*/React.createElement("g", {
    id: "t"
  }), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }), /*#__PURE__*/React.createElement("g", {
    id: "v"
  }), /*#__PURE__*/React.createElement("g", {
    id: "w"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x"
  }), /*#__PURE__*/React.createElement("g", {
    id: "y"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a`"
  }), /*#__PURE__*/React.createElement("g", {
    id: "aa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ag"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ah"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ai"
  }), /*#__PURE__*/React.createElement("g", {
    id: "aj"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ak"
  }), /*#__PURE__*/React.createElement("g", {
    id: "al"
  }), /*#__PURE__*/React.createElement("g", {
    id: "am"
  }), /*#__PURE__*/React.createElement("g", {
    id: "an"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ao"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ap"
  }), /*#__PURE__*/React.createElement("g", {
    id: "aq"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ar"
  }), /*#__PURE__*/React.createElement("g", {
    id: "as"
  }), /*#__PURE__*/React.createElement("g", {
    id: "at"
  }), /*#__PURE__*/React.createElement("g", {
    id: "au"
  }), /*#__PURE__*/React.createElement("g", {
    id: "av"
  }), /*#__PURE__*/React.createElement("g", {
    id: "aw"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ax"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ay"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b`"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.078e5fc2e1239d1183f9be93e48f5ad2.svg";
export { ForwardRef as ReactComponent };